'use client';

import { AuthContext } from '@/lib/auth/use-auth/auth-context';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect, useRef } from 'react';

export function AuthRedirectHandler() {
  const searchParams = useSearchParams();
  const processedRef = useRef(false);

  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (!authContext || !authContext.setAuth) {
      return;
    }

    const { setAuth } = authContext;
    const authSuccess = searchParams.get('auth_success');
    const userData = searchParams.get('user_data');
    const authToken = searchParams.get('auth_token') || '';

    if (authSuccess === 'true' && userData && !processedRef.current) {
      try {
        processedRef.current = true;
        const decodedUserData = JSON.parse(decodeURIComponent(userData));

        const userObj = {
          customerId: decodedUserData.customerId,
          email: decodedUserData.email || '',
          certificateName: decodedUserData.certificateName || '',
          phone: decodedUserData.phone || '',
          status: decodedUserData.status || 'ACTIVE',
          picture: decodedUserData.picture || '',
          id: decodedUserData.id,
          name: decodedUserData.name || '',
          gender: decodedUserData.gender || '',
        };

        setAuth(userObj, authToken);

        if (typeof window !== 'undefined') {
          const url = new URL(window.location.href);

          url.searchParams.delete('auth_success');
          url.searchParams.delete('user_data');
          url.searchParams.delete('auth_token');

          window.history.replaceState({}, '', url.toString());
        }
      } catch (error) {
        console.error('Error processing auth data:', error);
      }
    }
  }, [searchParams, authContext]);

  return null;
}
